import React from 'react';
import classNames from 'classnames';

import Styles from './icon.less';

const baseClass = Styles.baseClass;

class Icon extends React.Component {

  propTypes: {
    icon: React.PropTypes.string.isRequired,
    onClick: React.PropTypes.func
  }

  get types() {
    return [
      'icon',
      'fa'
    ];
  }

  getClass() {
    var type = this.props.icon.split('-').shift();
    if (this.types.indexOf(type) === -1) return '';

    return classNames(baseClass, type, this.props.icon, this.props.className);
  }

  render() {
    return require('./icon.rt').apply(this);
  }
}

module.exports = Icon;


/** WEBPACK FOOTER **
 ** ./src/icons/icon/index.js
 **/